module.exports = __webpack_public_path__ + "img/instagram-post.f5c44234.png";